module.exports = __webpack_public_path__ + "static/media/beach-4.b7fa54c4.jpg";